import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

const NotFound = () => {
  const location = useLocation();
  const { theme } = useThemeConfig();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div
      className="min-viewport-height flex items-center justify-center"
      style={{
        backgroundColor: theme.backgroundColor || "#f1f0fb",
        color: theme.textColor || "#000000",
      }}
    >
      <div className="text-center">
        <h1
          className="text-4xl font-bold mb-4"
          style={{ color: theme.sectionTitleColor }}
        >
          404
        </h1>
        <p className="text-xl mb-4" style={{ color: theme.sectionTextColor }}>
          Oops! Page not found
        </p>
        <a
          href="/"
          className="underline hover:text-[var(--link-hover)]"
          style={{
            color: theme.primaryColor,
            "--link-hover": theme.textPrimaryColor,
          } as React.CSSProperties}
        >
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
